import { Mark } from '@/plugins/api'
import alert from '@/plugins/alert'
import utils from '../../plugins/utils'
import { orderBy } from 'lodash'

export default {
  namespaced: true,
  state: {
    marks: [],
    students: [],
    factors: [],
    subject: {}
  },
  actions: {
    async fetchMarks({ commit }, options) {
      try {
        commit('setMarks', await Mark.fetch(options))
      } catch (error) {
        alert.error(error)
      }
    },
    setStudents({ commit }, students) {
      commit('setStudents', utils.sortListByName(students))
    },
    setFactors({ commit }, factors) {
      commit('setFactors', factors)
    },
    setSubject({ commit }, subject) {
      commit('setSubject', subject)
    }
  },
  mutations: {
    setMarks(state, marks) {
      state.marks = marks
    },
    setStudents(state, students) {
      state.students = students
    },
    setFactors(state, factors) {
      state.factors = factors
    },
    setSubject(state, subject) {
      state.subject = subject
    }
  },
  getters: {
    marks: state => {
      return state.students.reduce((acc, student) => {
        const marks = state.factors.reduce((acc, factor) => {
          const markObject = state.marks.filter(m => m.factor.id === factor.id && m.student.id === student.id) // tìm điểm theo factor và student tương ứng
          // .reduce((acc, mark) => ({ ...acc, [mark.data.index]: mark }), {}) // đánh dấu diểm theo index
          // let markByFactor = Array.from(Array(factor.quantity).keys()).map(index => markObject[index] || {}) // khớp điểm

          // mac dinh hien thi 8 o diem
          // const length = state.subject.markType === 'mark' ? 8 : 5
          let markByFactor = Array.from(Array(state.subject.markType === 'mark' ? 8 : 5).keys()).map(index => markObject[index] || {})
          markByFactor = orderBy(markByFactor, ['date'], ['asc'])

          return [...acc, ...markByFactor]
        }, []) // build factor schema

        return [...acc, { student, marks }]
      }, [])
    },
    students: state => {
      return state.students
    },
    factors: state => {
      return state.factors
    }
  }
}
